import React, { useEffect, useState } from 'react';
import CryptoJS from "crypto-js"
import api from '../../../services/api';
import { useNavigate } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import CustomizedTables from '../../../components/Table';
import PaginationRounded from '../../../components/NewPagination';
import LoadingComponent from '../../../components/LoadingComponent';
import FixedContainer from '../../../components/Container';
import { GetFetch } from '../../../services/apiBase';

const ListaTickets = ({ history }) => {

  const navigate = useNavigate()

  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(false);

  const [tickets, setTickets] = useState(null);
  const [name, setName] = useState('BALANCE_EXPIRED');
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(0);

  const getTickets = async () => {
    setLoading(true)
    try {

      // https://api.qa.finpec.agr.br/tickets?name=CPR_RENEW

      const response = await GetFetch(`/tickets?name=${name}&page=${currentPage}&limit=${limit}`);
      setTickets(response.data.data)
      setLimit(response.data.perPage);
      setTotalPages(response.data.lastPage);
      setError(false)

    } catch (error) {
      console.log('ERROR METHOD: getTickets()');
      console.log(error);
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const handleOpenDetails = (ticket) => {
    return navigate('/ticket/details', { state: { ticketId: ticket.id } })
  }

  const statusDict = {
    OPEN: 'Aberto',
    UPDATE: 'Atualizado',
    CLOSE: 'Fechado',
    FINISHED: 'Finalizado'
  }

  const COLUMNSTABLE = [
    {
      headerName: 'Relação',
      type: 'default',
      value: {
        first: {
          value: 'relation_id'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Descrição',
      type: 'default',
      value: {
        first: {
          value: 'description'
        }
      }
    },
    {
      headerName: 'Criado por',
      type: 'default',
      value: {
        first: {
          value: 'created_by'
        }
      }
    },
    {
      headerName: 'Status',
      type: 'default',
      value: {
        first: {
          value: 'current_status'
        }
      }
    },
    {
      headerName: 'Encerrado',
      type: 'bool',
      value: {
        first: {
          value: 'is_closed'
        }
      },
      trueMessage: 'Sim',
      falseMessage: 'Não',
      noData: 'Não informado'
    },

  ]

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar os cupons
        </Typography>
      </Box>
    )
  }

  const tableComponent = () => {
    return (
      <Box>
        {tickets && tickets.length > 0
          ?
          <>
            <CustomizedTables
              data={tickets}
              columns={COLUMNSTABLE}
              options
              action={handleOpenDetails}
            />
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              paddingTop: 2
            }}>
              <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
            </Box>
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              No momento não há Tickets para serem mostradas aqui
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  useEffect(() => {
    getTickets();
  }, [setTickets, currentPage]);

  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            Lista de Tickets
          </Typography>

          <Box>
            {loading ? <LoadingComponent /> :
              error ? errorMessage() :
                <>
                  {tableComponent()}
                </>
            }
          </Box>
        </Box>
      </FixedContainer>
    </>
  );
}

export default ListaTickets;